// extracted by mini-css-extract-plugin
export var container = "_5l-1";
export var editor = "_5l-2";
export var resizable = "_5l-3";
export var wrapper = "_5l-0";